import { Sunrise, Sun, Sunset, Moon } from 'lucide-react'
import { Battery, BatteryLow, BatteryMedium, BatteryFull, Fuel } from 'lucide'

export function capitalizeFirstLetter(string) {
  if (!string) return string
  return string[0].toUpperCase() + string.substring(1)
}

// Returns the Lucide IconNode and a colour hint for the popup's battery/fuel icon.
// Callers render the icon with lucide's `createElement` and apply the colour as the
// SVG stroke. Electric vehicles get a battery bucket (4 levels); other propulsion
// types fall back to the Fuel icon.
export function choosePopupBatteryIcon(batteryValue, vehiclePropulsionType) {
  if (vehiclePropulsionType !== 'electric') {
    return { Icon: Fuel, color: '#333333' }
  }

  if (batteryValue < 20) return { Icon: Battery, color: '#e53935' }
  if (batteryValue < 50) return { Icon: BatteryLow, color: '#f4a700' }
  if (batteryValue < 80) return { Icon: BatteryMedium, color: '#9eb723' }
  return { Icon: BatteryFull, color: '#4caf50' }
}

export function mapStyleSelectName(style) {
  switch (style) {
    case 'dawn':
      return (
        <>
          <Sunrise size={16} /> Morning
        </>
      )
    case 'day':
      return (
        <>
          <Sun size={16} /> Day
        </>
      )
    case 'dusk':
      return (
        <>
          <Sunset size={16} /> Evening
        </>
      )
    case 'night':
      return (
        <>
          <Moon size={16} /> Night
        </>
      )
    default:
      return (
        <>
          <Sun size={16} /> Day
        </>
      )
  }
}
